import { kml } from "@tmcw/togeojson";

/**
 * Parse a KML file and return a GeoJSON FeatureCollection containing
 * only Polygon and MultiPolygon geometries.
 */
export const parseKMLFile = (
  file: File,
): Promise<GeoJSON.FeatureCollection> => {
  return new Promise((resolve, reject) => {
    // Validate extension
    if (!file.name.toLowerCase().endsWith(".kml")) {
      reject(new Error("Invalid file extension. Only .kml files are accepted."));
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const parser = new DOMParser();
        const kmlDoc = parser.parseFromString(
          e.target!.result as string,
          "text/xml",
        );
        const geojson = kml(kmlDoc);

        // Filter to only Polygon/MultiPolygon features
        const filtered: GeoJSON.FeatureCollection = {
          ...geojson,
          features: geojson.features.filter(
            (f) =>
              f.geometry &&
              (f.geometry.type === "Polygon" ||
                f.geometry.type === "MultiPolygon"),
          ) as GeoJSON.Feature[],
        };

        if (filtered.features.length === 0) {
          reject(
            new Error(
              "No Polygon or MultiPolygon geometries found in KML file.",
            ),
          );
          return;
        }

        resolve(filtered);
      } catch {
        reject(new Error("Failed to parse KML file."));
      }
    };
    reader.onerror = () => reject(new Error("Failed to read file."));
    reader.readAsText(file);
  });
};
